// src/slice/authSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { Navigate } from "react-router-dom";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: null,
  },
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
    },
    setUserData(state, action){
        state.userData = action.payload;
    },
    logout(state) {
      state.token = null;
      state.userData = null;

    },
  },
});

export const { setToken, setUserData,logout } = authSlice.actions;
export default authSlice.reducer;
